import type { MessageKey } from '../i18n/catalog';

export const householdSharingErrorMessageKey = (error: unknown): MessageKey => {
  const code = error instanceof Error
    ? error.message
    : typeof error === 'object' && error != null && 'code' in error && typeof error.code === 'string'
      ? error.code
      : null;
  switch (code) {
    case 'ACCOUNT_HANDLE_INVALID': return 'sharing.errorHandleInvalid';
    case 'ACCOUNT_HANDLE_UNAVAILABLE': return 'sharing.errorHandleUnavailable';
    case 'ACCOUNT_CONTACT_INVALID': return 'sharing.errorContactInvalid';
    case 'ACCOUNT_PASSPHRASE_INVALID': return 'sharing.errorPassphraseInvalid';
    case 'ACCOUNT_LOGIN_INVALID': return 'sharing.errorLoginInvalid';
    case 'ACCOUNT_RECOVERY_INVALID': return 'sharing.errorRecoveryInvalid';
    case 'ACCOUNT_SESSION_REQUIRED': return 'sharing.errorSessionExpired';
    default: return error instanceof TypeError ? 'sharing.errorNetwork' : 'sharing.error';
  }
};
